import { Component, OnInit } from '@angular/core';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { Router } from '@angular/router';
import { FormHelper } from '../../../../../../../shared/form-helper';
import { TranslocoService } from '@ngneat/transloco';
import { RecommendationModel } from 'projects/core/src/lib/models/recommendation.model';

@Component({
  selector: 'app-recommendation-new',
  templateUrl: './recommendation-new.component.html',
  styleUrls: ['./recommendation-new.component.scss']
})
export class RecommendationNewComponent extends BaseForm implements OnInit {

  public form = this.fb.group({
    name_de: new UntypedFormControl('', [Validators.required]),
    name_en: new UntypedFormControl('', [Validators.required])
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit(): void {
    this.ui.setFormFocus();
  }

  onCancel(): void {
    this.router.navigate(['/recommendations']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('recommendations', null, this.form.value).subscribe({
        next: (result: any) => {
          const recommendation = new RecommendationModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: recommendation.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.saved'));
          this.router.navigate(['/recommendations', recommendation.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

}
